import { BrowserRouter } from 'react-router-dom';

import SalesforceChatbot from 'src/components/SalesforceChatbot';

import UnauthenticatedRoutes from './UnauthenticatedRoutes';
import AuthenticatedRoutes from './AuthenticatedRoutes';

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <UnauthenticatedRoutes />
      <AuthenticatedRoutes />
      <SalesforceChatbot />
    </BrowserRouter>
  );
};

export default Router;
